import api from '@/utils/api';

/**
 * Bulk import a company Price list
 * @param {object} bulkImportData - The bulk Import data
 * @param {string} companyId - the companyId
 * @returns {Promise}
 */
const bulkImportPriceList = (bulkImportData, companyId) =>
  api.post(`/company/${companyId}/price/bulk-import`, bulkImportData);

export default bulkImportPriceList;
